<template>
    <div :class="{ 'active show': active, 'disabled': disabled }"
         class="tab-pane fade"
         :id="label"
         role="tabpanel"
         :aria-labelledby="label + '-tab'">
        <slot v-if="!disabled" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { kebabCase } from 'lodash'

export default defineComponent({
    name: 'NavTabContent',
    props: {
        active: Boolean,
        disabled: Boolean,
        title: String,
    },
    computed: {
        label() {
            return kebabCase(this.title)
        }
    },
});
</script>
